import 'vuetify/src/stylus/app.styl';
import {
	Vuetify,
	VAlert,
	VApp,
	VAutocomplete,
	VBtn,
	VBtnToggle,
	VCard,
	VCheckbox,
	VChip,
	VDataIterator,
	VDatePicker,
	VDialog,
	VDivider,
	VForm,
	VGrid,
	VIcon,
	VList,
	VMenu,
	VNavigationDrawer,
	VRadioGroup,
	VSelect,
	VSlider,
	VSnackbar,
	VSubheader,
	VTextField,
	VTimePicker,
	VToolbar,
	VTooltip,
	transitions,
	VExpansionPanel,
	VDataTable,
	VProgressLinear,
	VProgressCircular,
	VTabs,
	VTextarea,
	VStepper,
	VSwitch,
	VTreeview,
	VAvatar,
	VInput,
	VRating,
	VRangeSlider,
	VBreadcrumbs,
	VPagination,
} from 'vuetify';

export default function (Vue) {
	Vue.use(
		Vuetify,
		{
			components: {
				VRangeSlider,
				VAvatar,
				VAlert,
				VApp,
				VAutocomplete,
				VBtn,
				VBreadcrumbs,
				VBtnToggle,
				VCheckbox,
				VChip,
				VCard,
				VDataIterator,
				VDatePicker,
				VDialog,
				VDivider,
				VForm,
				VGrid,
				VIcon,
				VInput,
				VList,
				VMenu,
				VNavigationDrawer,
				VRadioGroup,
				VSelect,
				VSlider,
				VSnackbar,
				VSubheader,
				VTextField,
				VTimePicker,
				VToolbar,
				VTooltip,
				transitions,
				VExpansionPanel,
				VDataTable,
				VProgressLinear,
				VProgressCircular,
				VTabs,
				VTextarea,
				VStepper,
				VSwitch,
				VTreeview,
				VRating,
				VPagination,
			},
			theme: {
				primary: '#487fff',
				secondary: '#B2E0F9',
				accent: '#005CAF',
				error: '#f42b17',
				info: '#606560',
				success: '#5ed52b',
				warning: '#FFB74C',
			},
		},
	);
}



// WEBPACK FOOTER //
// ./src/vuetify.js